import { render, staticRenderFns } from "./printTemplateSelector.vue?vue&type=template&id=4f747222&scoped=true&"
import script from "./printTemplateSelector.vue?vue&type=script&lang=js&"
export * from "./printTemplateSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f747222",
  null
  
)

export default component.exports